/* eslint-disable react/jsx-props-no-spreading */
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import {
  Label,
  CustomDropdown,
} from './styles';

const SelectFormField = (props) => {
  const {
    field,
    form,
    labelFontSize,
    labelWeight,
    labelColor,
    label,
    placeholder,
    isMulti,
    icon,
    audience,
    loading,
    options,
    noResultsMessage,
    disabled,
    selectOnBlur,
  } = props;

  const { errors, touched, setFieldValue } = form;
  const { name, value } = field;

  return (
    <>
      <Label
        error={field && name && _.get(errors, name) && _.get(touched, name)}
        fontSize={labelFontSize}
        weight={labelWeight}
        color={labelColor}
      >
        {label}
      </Label>
      <CustomDropdown
        placeholder={placeholder}
        fluid
        multiple={isMulti}
        search
        icon={icon}
        value={value}
        selection
        audience={audience}
        loading={loading}
        options={options}
        error={field && name && (_.get(touched, name) && _.get(errors, name)) === true}
        onChange={(e, { value: selectedValue }) => setFieldValue(name, selectedValue)}
        noResultsMessage={noResultsMessage || 'No results found'}
        disabled={disabled}
        selectOnBlur={selectOnBlur}
      />
    </>
  );
};

SelectFormField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.shape(),
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape(),
    touched: PropTypes.shape(),
    setFieldValue: PropTypes.func,
  }).isRequired,
  labelFontSize: PropTypes.string,
  labelWeight: PropTypes.string,
  labelColor: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isMulti: PropTypes.bool,
  icon: PropTypes.string,
  audience: PropTypes.bool,
  loading: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape()),
  noResultsMessage: PropTypes.string,
  disabled: PropTypes.bool,
  selectOnBlur: PropTypes.bool,
};

SelectFormField.defaultProps = {
  labelFontSize: undefined,
  labelWeight: undefined,
  labelColor: undefined,
  label: '',
  placeholder: undefined,
  isMulti: undefined,
  icon: undefined,
  audience: undefined,
  loading: undefined,
  options: [],
  noResultsMessage: undefined,
  disabled: undefined,
  selectOnBlur: false,
};

export default SelectFormField;
